import { CommonModule } from '@angular/common';
import { Component, Inject, HostListener } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MaterialModule } from '../../shared/material.module';
import { TranslatePipe } from '../../pipes/translate.pipe';

export interface PhotoPreviewDialogData {
  imageUrl: string;
  isPdf?: boolean;
  fileName?: string;
}

@Component({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslatePipe
  ],
  selector: 'photo-preview-dialog',
  templateUrl: './photo-preview-dialog.component.html',
  styleUrls: ['./photo-preview-dialog.component.scss']
})
export class PhotoPreviewDialogComponent {
  isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

  constructor(
    public dialogRef: MatDialogRef<PhotoPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: PhotoPreviewDialogData,
    private sanitizer: DomSanitizer
  ) { }

  get safePdfUrl(): SafeResourceUrl | null {
    if (!this.data.isPdf || !this.data.imageUrl) {
      return null;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(this.buildEmbeddedPdfUrl(this.data.imageUrl));
  }

  private buildEmbeddedPdfUrl(url: string): string {
    const viewerParams = 'navpanes=0&pagemode=none&toolbar=0&view=FitH';
    return url.includes('#') ? `${url}&${viewerParams}` : `${url}#${viewerParams}`;
  }

  close(): void {
    this.dialogRef.close();
  }

  @HostListener('keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.close();
    }
  }
}
